import { render, staticRenderFns } from "./TestTable.vue?vue&type=template&id=baa74206&scoped=true"
import script from "./TestTable.vue?vue&type=script&lang=js"
export * from "./TestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa74206",
  null
  
)

export default component.exports